"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultDeliveryFrequency = void 0;
var _utils = require("./components/SelectDeliveryFrequency/utils");
const getDefaultDeliveryFrequency = ({
  deliveryFrequencyOptions,
  recommendedFrequency,
  translations
}) => {
  const options = (0, _utils.mapFrequencyDeliveryOptions)({
    deliveryFrequencyOptions,
    recommendedFrequency,
    translations
  });
  return options.some(option => option.value === recommendedFrequency) ? recommendedFrequency : options[0]?.value ?? 1; // 1 is for type safety when options is empty and recommendedFrequency is undefined
};
exports.getDefaultDeliveryFrequency = getDefaultDeliveryFrequency;
